import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import DocIcon from "../../assets/img/DocIcon.svg";
import VactorIcon3 from "../../assets/img/VactorIcon3.svg";
import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { useEffect, useState } from "react";
import FilePreviewModal from "../FilePreviewmodal";

const DataInfoModal = ({
  isOpen,
  onClose,
  infoModal,
  verifiedDocs,
  claveDocs,
  docsMap,
  forensicAnalysis,
  uploadedTenantDocs = [],
  hideDownload = false,
}) => {
  const { _t } = useTranslator();

  const [documentGalleryData, setDocumentGalleryData] = useState([]);
  const [filePreview, showFilePreview] = useState(false);
  const [showIndex, setShowIndex] = useState(null);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);
  useEffect(() => {
    if (!isOpen) return;

    const uploadedDocsByFileName = {};
    uploadedTenantDocs.forEach((d) => {
      const fileName = d?.file_name || d?.url?.split("/")?.pop();
      if (fileName) {
        uploadedDocsByFileName[fileName] = d;
      }
    });

    const result = [];

    if (
      Array.isArray(infoModal?.foundInDocuments) &&
      docsMap &&
      verifiedDocs instanceof Map
    ) {
      infoModal.foundInDocuments.forEach((doc) => {
        const docMeta = docsMap[doc?.documentId ?? doc?.document_id];
        // Payslip instances share a document_id, but each file_url identifies
        // the actual uploaded document represented by this row.
        const url = doc?.file_url || doc?.fileUrl || doc?.url || docMeta?.url;
        if (!url) return;
        const uploadKey = url?.split("uploads/")[1];

        const isVerified = verifiedDocs.has(uploadKey);
        const isClave = claveDocs instanceof Map && claveDocs.has(uploadKey);

        const matchedUploaded = uploadedDocsByFileName[uploadKey];
        const signedUrl = matchedUploaded?.url || url;

        result.push({
          ...doc,
          url: signedUrl,
          file_name: uploadKey,
          tick: isVerified,
          clave: isClave,
        });
      });
    }

    setDocumentGalleryData(result);
  }, [infoModal, docsMap, verifiedDocs, claveDocs, isOpen, uploadedTenantDocs]);

  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal wrapper-modal info-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between doc-history-header">
          <div className="doc-history-header p-0 m-0">
            <img
              src={CloseIcon}
              alt=""
              className="doc-history-close-btn"
              onClick={onClose}
            />
            <h4 className="custom-modal-heading">{_t("dataInfo")}</h4>
          </div>
          <div className="col-6 text-end">
            <div className="d-flex align-items-center justify-content-end">
              {(infoModal?.verifiedSource === true ||
                (forensicAnalysis?.Income?.verifiedSource === true &&
                  infoModal?.verified === true)) && (
                <div className="verifyBtn d-flex gap-2 align-items-center">
                  <img src={CheckIcon0} alt="Vector Icon" />
                  <p className="inpitplaceholder inpitplaceholder2">
                    {_t("Verified")}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="h-100 overflow-y-auto overflow-x-hidden">
          <div className="row d-flex align-items-center ">
            <div className="col-12">
              <div className="">
                <p className="inpitnamehere">
                  {haveValue(infoModal?.keyFactor)
                    ? _t(infoModal?.keyFactor?.toLowerCase())
                    : _t("payslip")}
                </p>
                <p className="inpitplaceholder">
                  {(() => {
                    const val = haveValue(
                      infoModal?.value?.[currentLang === "es" ? "es" : "en"]
                    )
                      ? infoModal?.value?.[currentLang === "es" ? "es" : "en"]
                      : haveValue(infoModal?.netIncome)
                        ? `€${infoModal?.netIncome}`
                        : "N/A";

                    if (typeof val === "string" && val.includes(". ")) {
                      return val.split(". ").map((part, index, array) => (
                        <span key={index}>
                          {part}
                          {index < array.length - 1 ? "." : ""}
                          {index < array.length - 1 && <br />}
                        </span>
                      ));
                    }
                    return val;
                  })()}
                </p>
              </div>
            </div>
          </div>

          <div className="earner-card-wrapper earner-card-new">
            <div className="statusComponent mb-2">
              <p className="statusText">{_t("status")}</p>
              <p className="statusText2">
                {console.log("infoModal", infoModal)}
                {infoModal?.consistentAcrossDocuments || // updated key
                infoModal?.consitentAccrosDocuments || // for old users
                (forensicAnalysis?.Income?.verifiedSource === true &&
                  infoModal?.verified)
                  ? _t("consistent")
                  : _t("notConsistent")}
              </p>
              <p className="statusText">{_t("remarks")}</p>
              <p className="statusText3">
                {(typeof infoModal?.remarks === "object"
                  ? infoModal?.remarks?.[currentLang === "es" ? "es" : "en"]
                  : infoModal?.remarks
                )
                  ?.split(". ")
                  .map((s) => s.trim())
                  .filter(Boolean).length ? (
                  <ul className="remarks-ul">
                    {(typeof infoModal?.remarks === "object"
                      ? infoModal?.remarks?.[currentLang === "es" ? "es" : "en"]
                      : infoModal?.remarks
                    )
                      ?.split(". ")
                      .map((s) => s.trim())
                      .filter(Boolean)
                      .map((tag, i) => (
                        <li key={i}>{tag}</li>
                      ))}
                  </ul>
                ) : (
                  "N/A"
                )}
              </p>
            </div>
          </div>
          {documentGalleryData.length > 0 && (
            <div className="documents_fixed_div">
              <h4>{_t("foundInDocuments")}</h4>
              <div className="documents_fixed">
                {documentGalleryData?.map((doc, index) => (
                  <div
                    key={doc?.instance_id || doc?.file_url || index}
                    className="d-flex align-items-center gap-4 justify-content-between BorderB2"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div className="docList">
                        <img
                          src={DocIcon}
                          alt="Vector Icon"
                          className="vactorImg2"
                        />
                      </div>
                      <div
                        onClick={(e) => {
                          setShowIndex(index);
                          showFilePreview(true);
                        }}
                        className="texReport_div text-decoration-underline-hover cursor-pointer"
                      >
                        {/* <p>{_t(doc?.documentName, "", "fixed")}</p> */}
                        <p>
                          {doc?.localDocumentName?.[
                            currentLang === "es" ? "es" : "en"
                          ] ||
                            doc?.documentNameTranslated?.[
                              currentLang === "es" ? "es" : "en"
                            ] ||
                            doc?.documentName ||
                            doc?.bucket_name ||
                            doc?.name}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      {doc?.clave && (
                        <div className="clickBtn2 d-flex align-items-center gap-2">
                          <img
                            src={VactorIcon3}
                            alt="Vector Icon"
                            className="vactorImg2"
                          />
                          <p>Cl@ve</p>
                        </div>
                      )}
                      {doc?.tick && (
                        <div>
                          <img
                            src={CheckIcon0}
                            alt="Vector Icon"
                            className="vactorImg"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <FilePreviewModal
        show={filePreview}
        onClose={() => {
          showFilePreview(false);
        }}
        files={documentGalleryData}
        showIndex={showIndex}
        hideDownload={hideDownload}
      />
    </div>
  );
};

export default DataInfoModal;
